module.exports = __webpack_public_path__ + "static/img/MGVAGV-p.5f69513.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/MGVAGV-p.png
// module id = 0RLi
// module chunks = 1